<template>
  <div>
    <div
      :style="{
        position: 'absolute',
        width: mmToEm(selectedUprights.width),
        height: mmToEm(selectedHeight),
        background: gableColor,
        zIndex: 1000
      }"
    >
      <div
        :style="{
          position: 'absolute',
          boxSizing: 'border-box',
          left: mmToEm(20),
          width: mmToEm(selectedUprights.width - 40),
          height: mmToEm(selectedHeight),
          borderRight: mmToEm(15) + ' dashed white',
          borderLeft: mmToEm(15) + ' dashed white',
          background: gableColor,
          zIndex: 1000
        }"
      />

      <div
        v-show="includeImpactProtectors && isLeftmost"
        :style="{
          position: 'absolute',
          boxSizing: 'border-box',
          left: mmToEm(-175),
          top: mmToEm(selectedHeight - 400),
          zIndex: 1000
        }"
      >
        <div
          :style="{
            position: 'absolute',
            height: mmToEm(120),
            width: mmToEm(75),
            top: mmToEm(20),
            background: impactProtectorColor
              
          }"
        />
        <div
          :style="{
            position: 'absolute',
            height: mmToEm(120),
            width: mmToEm(75),
            top: mmToEm(150),
            background: impactProtectorColor
          }"
        />

        <div
          :style="{
            position: 'absolute',
            left: mmToEm(75),
            height: mmToEm(400),
            width: mmToEm(80),
            top: mmToEm(0),
            background:
              gableColor
          }"
        />
      </div>

      <div
        v-show="includeUprightProtectors"
        :style="{
          position: 'absolute',
          left: mmToEm(-(150 - selectedUprights.width) / 2),
          top: mmToEm(selectedHeight - 290),
          height: mmToEm(300),
          width: mmToEm(150),
          borderTopLeftRadius: mmToEm(75),
          borderTopRightRadius: mmToEm(75),
          background: uprightProtectorColor,
          zIndex: 1020
        }"
      />
      <!-- 
      <div :style="{
          position: 'absolute',
          left: mmToEm(-(210 - selectedUprights.width) / 2),
          top: mmToEm(selectedHeight - 20),
          height: mmToEm(20),
          width: mmToEm(210),
          background: impactProtectorColor,
          zIndex: 1021              
      }">
      </div> -->
    </div>

    <div
      v-if="isRightmost"
      :style="{
        position: 'absolute',
        left: mmToEm(sector.beam.length + selectedUprights.width),
        width: mmToEm(selectedUprights.width),
        height: mmToEm(selectedHeight),
        background:
          gableColor,
        zIndex: 1000
      }"
    >
      <div
        :style="{
          position: 'absolute',
          left: mmToEm(20),
          width: mmToEm(selectedUprights.width - 40),
          height: mmToEm(selectedHeight),
          borderRight: mmToEm(15) + ' dashed white',
          borderLeft: mmToEm(15) + ' dashed white',
          background:
            gableColor,
          zIndex: 1000
        }"
      />

      <div
        v-show="includeImpactProtectors && isRightmost"
        :style="{
          position: 'absolute',
          boxSizing: 'border-box',
          right: mmToEm(-20),
          top: mmToEm(selectedHeight - 400),
          zIndex: 1000
        }"
      >
        <div
          :style="{
            position: 'absolute',
            height: mmToEm(120),
            width: mmToEm(75),
            left: mmToEm(75),
            top: mmToEm(20),
            background:
              impactProtectorColor
          }"
        />
        <div
          :style="{
            position: 'absolute',
            height: mmToEm(120),
            width: mmToEm(75),
            left: mmToEm(75),
            top: mmToEm(150),
            background:
              impactProtectorColor
          }"
        />

        <div
          :style="{
            position: 'absolute',
            height: mmToEm(400),
            width: mmToEm(80),
            top: mmToEm(0),
            background:
              gableColor
          }"
        />
      </div>

      <div
        v-show="includeUprightProtectors"
        :style="{
          left: mmToEm(-(150 - selectedUprights.width) / 2),
          top: mmToEm(selectedHeight - 290),
          position: 'absolute',
          height: mmToEm(300),
          width: mmToEm(150),
          borderTopLeftRadius: mmToEm(75),
          borderTopRightRadius: mmToEm(75),
          background:
            impactProtectorColor,
          zIndex: 1020
        }"
      />

      <!-- <div :style="{
          position: 'absolute',
          left: mmToEm(-(210 - selectedUprights.width) / 2),
          top: mmToEm(selectedHeight - 20),
          height: mmToEm(20),
          width: mmToEm(210),
          background: impactProtectorColor,
          zIndex: 1021              
      }"> 
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    isLeftmost: Boolean,
    isRightmost: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    sector: Object
  },
  data() {
    return {
      uprightProtectorColor: 'linear-gradient(90deg, rgba(255,108,72,1) 0%, rgba(250,42,0,1) 10%, rgba(250,25,0,1) 45%, rgba(250,25,0,1) 55%, rgba(209,28,0,1) 90%, rgba(156,31,0,1) 100%)',
      gableColor: 'linear-gradient(90deg, rgba(201,201,201,1) 0%, rgba(147,147,147,1) 5%, rgba(131,131,131,1) 46%, rgba(112,112,112,1) 50%, rgba(143,143,143,1) 54%, rgba(131,131,131,1) 95%, rgba(75,75,75,1) 100%)',
      impactProtectorColor: 'linear-gradient(180deg, rgba(255,165,165,1) 0%, rgba(255,15,0,1) 3%, rgba(230,15,0,1) 15%, rgba(180,15,0,1) 16%, rgba(253,15,0,1) 97%, rgba(179,15,0,1) 100%)'
    }
  },
  computed: {
    ...mapState([
      "selectedUprights",
      "selectedHeight",
      "includeUprightProtectors",
      "includeImpactProtectors"
    ])
  },
  methods: {
    mmToEm(mm) {
      return mm / 1000 + "em";
    }
  }
};
</script>
